import crypto from 'crypto';

const MAX_BYTE_DECIMAL = 256;

function generateUnbiasedRandomNumber(limit: number): number {
  if (limit >= MAX_BYTE_DECIMAL) {
    // If we want to support this in the future... not sure if we will, then we'll have to generate several bytes
    //  to support the length
    throw new Error('Limit exceeds current implementation of cryptographically secure generation');
  }

  let randomByte;
  do {
    randomByte = crypto.randomBytes(1).readUInt8(0);
  } while (randomByte > Math.floor(MAX_BYTE_DECIMAL / limit) * limit);

  return randomByte % limit;
}

/**
 *
 * Generate a pseudo random code
 *
 * @param codeLength Length of the code to generate
 * @param characterSet Character set to generate the code from. Defaults to unambiguous letter set
 */
export function generate(
  codeLength: number,
  characterSet = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'
): string {
  const characters = [];

  for (let i = 0; i < codeLength; i += 1) {
    const randomByte = generateUnbiasedRandomNumber(characterSet.length);
    const character = characterSet[randomByte];
    characters.push(character);
  }

  return characters.join('');
}
